export const DRAFT_STATUSES = ['draft', 'sms_verificating'];
export const ACCEPT_STATUSES = [
  'approved',
  'accepted_alternative',
  'pre_approved'
];
export const ERROR_RESPONSE_STATUSES = [
  'declined',
  'cancelled',
  'error',
  'bank_response_timeout',
  'biometrics_failed'
];
export const ARCHIVED_STATUSES = [...ERROR_RESPONSE_STATUSES, 'financed'];

export const BOOKING_TIME_STATUSES = [
  ...DRAFT_STATUSES,
  'waiting_bank_response',
  'fc_taken_to_work'
];

export const BLUE_COLORED_STATUSES = [
  'client_accepted',
  'waiting_of_financing',
  'mobile_client',
  'financed_pledge_missing',
  'financed_waiting_for_modification_before_pledge',
  'waiting_for_upload_files',
  'waiting_for_docs_confirmation',
  'on_rework',
  'vehicle_registration',
  'refund_in_progress'
];

export const OFFERED_STATUSES = [
  ...BLUE_COLORED_STATUSES,
  'financed',
  'refunded'
];
